import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { Button, Col, Badge, Form, Row } from "react-bootstrap";
import {
  faEye,
  faGear,
  faNoteSticky,
  faSave,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import DetallePedido from "./trucks/turnero/DetallePedido";

function VentanaMovible({
  platillo,
  agregarplatillo,
  ingredientes,
  anadidos,
  detalleOrden,
  selectCostosItem,
  verDetalle,
  agregarNota,
  platinorder,
  handleNote,
  chico,
}) {
  const [estaAbierta, setEstaAbierta] = useState(false);
  const miDivRef = useRef(null);
  const [nota, setNota] = useState(platinorder?.note ? platinorder.note : "");

  const estilos = {
    ventana: {
      backgroundColor: "#fff",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
      borderRadius: "8px",
      overflow: "hidden",
      position: "fixed",
      width: "36rem",
      top: !verDetalle && !agregarNota ? "3rem" : "15rem",
      left: chico && "25rem",
      border: "1px solid #ccc",
      zIndex: 1066,
    },
    header: {
      // backgroundColor: "#333",
      // color: "#fff",
      borderBottom: "1px solid",
      padding: "10px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "move", // Indica al usuario que se puede mover
    },
    contenido: {
      maxHeight: "40rem",
      padding: "20px",
      overflowY: "auto",
    },
    botonCerrar: {
      background: "transparent",
      border: "none",
      color: "#000",
      cursor: "pointer",
      fontWeight: "bold",
    },
  };

  useEffect(() => {
    function handleClickFuera(event) {
      if (miDivRef.current && !miDivRef.current.contains(event.target)) {
        setEstaAbierta(false);
      }
    }
    document.addEventListener("mousedown", handleClickFuera);
    return () => {
      document.removeEventListener("mousedown", handleClickFuera);
    };
  }, []);

  useEffect(() => {
    if (agregarNota && platinorder?.note) {
      setNota(platinorder?.note ? platinorder?.note : "");
    } else {
      setNota("");
    }
  }, [agregarNota, platinorder?.note]);

  useEffect(() => {
    if (agregarNota && estaAbierta) {
      const notacamp = document.getElementById("notacamp");
      notacamp.focus();
    }
  }, [agregarNota, estaAbierta]);

  if (!estaAbierta) {
    if (verDetalle) {
      return (
        <Button
          variant="outline-dark"
          onClick={() => setEstaAbierta(true)}
          style={{ width: "40%", margin: 2 }}
        >
          <FontAwesomeIcon icon={faEye} />
          Ver
        </Button>
      );
    } else if (agregarNota && chico) {
      return (
        <Button variant="outline-dark" onClick={() => setEstaAbierta(true)}>
          <FontAwesomeIcon icon={faNoteSticky} />
        </Button>
      );
    } else if (agregarNota) {
      return (
        <Button
          variant="outline-dark"
          onClick={() => setEstaAbierta(true)}
          style={{ width: "40%", margin: 2 }}
        >
          <FontAwesomeIcon icon={faNoteSticky} />
          Nota
        </Button>
      );
    } else {
      return (
        <Button
          variant="success"
          id="agregar"
          onClick={() => setEstaAbierta(true)}
          style={{ width: "80%" }}
        >
          <FontAwesomeIcon icon={faGear} />
          Configurar
        </Button>
      );
    }
  }

  return (
    <Draggable handle=".ventana-header">
      <Col md={4} style={estilos.ventana} ref={miDivRef}>
        <div className="ventana-header" style={estilos.header}>
          <img
            src={platillo.img}
            alt=""
            width={"60rem"}
            height={"55rem"}
            style={{ objectFit: "contain", borderRadius: 7 }}
          />
          <h5>
            <strong>{platillo.name}</strong>
            <br />
            {selectCostosItem &&
              selectCostosItem?.ncosto +
                "$(" +
                parseFloat(selectCostosItem?.costo).toFixed(2) +
                ")"}
          </h5>
          <Badge
            bg="gray"
            style={{
              color: platillo?.modo ? "white" : "black",
              // margin: "auto",
              fontSize: 12,
              fontWeight: "600",
              marginBottom: 10,
              marginTop: 10,
              paddingTop: 7,
              paddingBottom: 7,
              backgroundColor: platillo?.modo
                ? platillo?.modo === "PREVENTA"
                  ? "purple"
                  : platillo?.modo === "RECOGER CON HORARIO"
                    ? "brown"
                    : "orange"
                : "orange",
            }}
          >
            {platillo?.modo
              ? platillo?.modo === "PREVENTA"
                ? "PREVENTA DISPONIBLE"
                : platillo?.modo === "RECOGER CON HORARIO"
                  ? "PEDIDO CON HORARIO PARA RECOGER"
                  : "PEDIDO PARA HOY"
              : "PEDIDO PARA HOY"}
          </Badge>
          <button
            onClick={() => setEstaAbierta(false)}
            style={estilos.botonCerrar}
          >
            X
          </button>
        </div>
        <div style={estilos.contenido}>
          {verDetalle &&
            (platillo.description === "" ? (
              <h3>Platillo sin descripcion</h3>
            ) : (
              <>
                <h3>Descripcion:</h3>
                <h4>{platillo.description}</h4>
              </>
            ))}
          {agregarNota && (
            <Row style={{ justifyContent: "center" }}>
              <Col md={12} style={{ paddingBottom: 18 }}>
                Nota
                <Form.Control
                  as="textarea"
                  id="notacamp"
                  rows={2}
                  value={nota}
                  placeholder="Añade comentarios a tu pedido"
                  onChange={(e) => {
                    setNota(e.target.value);
                  }}
                />
              </Col>
              <Button
                variant="danger"
                onClick={() => {
                  setNota(platinorder?.note ? platinorder.note : "");
                  setEstaAbierta(false);
                }}
                style={{ width: "40%", margin: 2 }}
              >
                <FontAwesomeIcon icon={faTrash} />
                Cancelar
              </Button>
              <Button
                variant="success"
                onClick={() => {
                  handleNote(platinorder, nota);
                  setEstaAbierta(false);
                }}
                style={{ width: "40%", margin: 2 }}
              >
                <FontAwesomeIcon icon={faSave} />
                Guardar
              </Button>
            </Row>
          )}
          {!verDetalle && !agregarNota && (
            <DetallePedido
              plati={platillo}
              anadidos={anadidos}
              ingredientes={ingredientes}
              detalleOrden={detalleOrden}
              handlebackPlatillos={() => setEstaAbierta(false)}
              anadirPedido={agregarplatillo}
              selectCostosItem={selectCostosItem}
            />
          )}
        </div>
      </Col>
    </Draggable>
  );
}

export default VentanaMovible;
